module.exports = __webpack_public_path__ + "img/bus-orange.40209331.svg";